/**
 * Lunar month, time between two successive syzygies of the
 * same type: new moons or full moons
 */
export enum LunarMonth {
  ANOMALISTIC = "Anomalistic",
  DRACONIC = "Draconic",
  SIDEREAL = "Sidereal",
  SYNODIC = "Synodic",
  TROPICAL = "Tropical",
}
